import BaseService from '@root/core/class/BaseService';
import { ReturnPagination } from '../../Inbound/Interface';
import returnImportPage from '@modules/Warehouse/Return/pages/ReturnImportPage';
class returnDisposalService extends BaseService {
  // get return disposal list
  public getReturnList = () => {
    return this.get('/returns');
  };

  // get return disposal detail
  public getDetailReturn = (id: string) => {
    return this.get(`/returns/${id}`);
  };

  // get return disposal with pagination
  public getReturnPagination = (
    page: number,
    sort?: boolean,
    fromDt?: string,
    toDt?: string,
    filterBy?: string,
    searchBy?: string,
    input?: string,
    isReturnProduct?: number,
    filter?: string
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    let url = `/returns?page=${page}&limit=10${
      (!!searchBy && !!inputUse
        ? `&searchBy=${searchBy}&search=${inputUse}`
        : '') +
      (!!filterBy ? `&filterBy=processType:${filterBy}` : '') +
      (!!fromDt ? `&fromDt=${fromDt}` : '') +
      (!!toDt ? `&toDt=${toDt}` : '') +
      (!!sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC') +
      (!!isReturnProduct ? `&isReturnProduct=${isReturnProduct}` : '') +
      (!!filter ? `&filter=${filter}` : '')
    }`;
    return this.get(url);
  };

  // put return save
  public putReturnSave = (
    id: string,
    status: string,
    updateDate?: string,
    courier?: string,
    trackingNumber?: string,
    deliveryStatus?: string,
  ) => {
    return this.put(`/returns/${id}`, {
      updateDate,
      status,
      courier,
      trackingNumber,
      deliveryStatus
    });
  };

  public updateOrderReturn = (
    id: number,
    status: string,
    updateDate?: string,
    courier?: string,
    trackingNumber?: string
  ) => {
    return this.put(`/deliveries/updateReturn`, {
      id,
      updateDate,
      status,
      courier,
      trackingNumber,
    });
  }

  public deleteReturn = (id: string) => {
    return this.delete(`/returns/${id}`);
  }

  // download returns
  public postDownloadExcel = () => {
    return this.post(
      '/returns/export',
      {},
      {
        responseType: 'blob'
      }
    );
  };

  // download search returns
  public exportExcel = ({
    sort,
    filterDateFrom,
    filterDateTo,
    filterBy,
    searchBy,
    valueSearch,
    isReturnProduct,
    filter
  }: ReturnPagination) => {
    let url = `/returns/export`;
    url =
      (!!searchBy && !!valueSearch) ||
      !!sort ||
      filterBy ||
      !!filterDateFrom ||
      !!filterDateTo
        ? url + '?'
        : url;

    url +=
      (!!searchBy && !!valueSearch
        ? `&searchBy=${searchBy}&search=${valueSearch}`
        : '') +
      (!!filterDateFrom ? `&fromDt=${filterDateFrom}` : '') +
      (!!filterBy ? `&filterBy=processType:${filterBy}` : '') +
      (!!filterDateTo ? `&toDt=${filterDateTo}` : '') +
      (sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC') +
      (!!isReturnProduct ? `&isReturnProduct=${isReturnProduct}` : '') +
      (!!filter ? `&filter=${filter}` : '');
    let urlUse = url.replace('?&', '?');
    return this.post(
      urlUse,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public postDownloadExcelId = (body: Record<string, any>, isReturnProduct?: number) => {
    let url = '/returns/export';
    url +=
      (!!isReturnProduct ? `?isReturnProduct=${isReturnProduct}` : '')
    return this.post(url, body, {
      responseType: 'blob'
    });
  };

  public updateReturn = (products: any, recipient: any, commentId: number, returnId: number) => {
    let url = `/returns/${returnId}/update`;
    return this.put(
      url,
      {
        products: products,
        recipient: recipient,
        commentId: commentId
      }
    );
  }
}

export default new returnDisposalService('/api/v1/warehouse', true);
